'use client'

import { ActionWorldCardSkeleton } from '@/components/ActionWorldCard'
import ViverseSkeleton from '@/components/ViverseSkeleton'

function SectionSkeleton() {
  return (
    <div className="flex flex-col gap-4 md:gap-9">
      <div className="flex flex-col gap-2 md:gap-4">
        <ViverseSkeleton className="h-6 w-32 rounded-lg md:h-8 md:w-48" />
        <ViverseSkeleton className="h-3 w-48 rounded-lg md:h-4 md:w-96" />
      </div>
      <div className="no-scrollbar flex gap-4 overflow-hidden md:gap-2 lg:flex-wrap lg:gap-2">
        {[1, 2, 3, 4].map((i) => (
          <ActionWorldCardSkeleton
            key={i}
            className="max-w-[280px] min-w-[280px] md:max-w-[306px] md:min-w-[306px] lg:max-w-[322px] lg:min-w-[322px]"
          />
        ))}
      </div>
    </div>
  )
}

export default function ProfileSkeleton() {
  return (
    <div className="animate-in fade-in h-screen overflow-hidden duration-500">
      {/* Banner Skeleton */}
      <section className="px-4 py-2 md:px-8 md:py-4 md:pt-8 lg:px-18">
        <ViverseSkeleton className="aspect-358/96 w-full rounded-2xl md:aspect-704/152 lg:aspect-1296/280" />
      </section>

      {/* Intro Skeleton */}
      <section className="px-4 py-2 md:px-8 md:py-4 lg:px-18">
        <div className="flex flex-col gap-4 md:flex-row md:justify-between">
          <div className="flex flex-col items-center gap-4 md:flex-row md:items-start">
            {/* Avatar Skeleton */}
            <ViverseSkeleton className="size-16 rounded-full md:size-24 lg:size-[100px]" />

            <div className="mt-1 flex flex-col gap-2 md:mt-2">
              <div className="flex flex-col items-center gap-2 md:items-start">
                <ViverseSkeleton className="h-6 w-32 rounded-lg md:h-8 md:w-48" />
                <ViverseSkeleton className="h-3 w-24 rounded-lg md:h-4 md:w-32" />
              </div>
              <div className="mt-1 flex gap-2 md:mt-2">
                <ViverseSkeleton className="h-6 w-16 rounded-full md:h-7 md:w-20" />
                <ViverseSkeleton className="h-6 w-16 rounded-full md:h-7 md:w-20" />
              </div>
            </div>
          </div>
          <ViverseSkeleton className="hidden h-12 w-40 rounded-full md:block" />
        </div>
      </section>

      {/* Content Skeleton */}
      <div className="flex flex-col gap-6 px-4 py-4 md:gap-12 md:px-8 lg:px-18 lg:py-8">
        {/* Anchors Skeleton */}
        <div className="no-scrollbar flex gap-2 overflow-hidden md:gap-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <ViverseSkeleton key={i} className="h-8 w-16 shrink-0 rounded-lg md:h-10 md:w-24" />
          ))}
        </div>

        {/* Sections */}
        <div className="flex flex-col gap-8 md:gap-12">
          <SectionSkeleton />
          <SectionSkeleton />
        </div>
      </div>
    </div>
  )
}
